import { Dispatch, SetStateAction } from "react"
import { Button } from "@/components/ui/button"
import { ThumbsDown, ThumbsUp } from "lucide-react"
import { cn } from "@/lib/utils"
import { MessageFeedbackModal } from "./message-feedback-modal"
import { useFeedbackMessage } from "../../../hooks/useMessageFeedback"
import type { FeedbackType } from '@/api/types/workstation.types'

interface MessageFeedbackProps {
  messageId: string;
  onFeedbackSubmit: (
    type: FeedbackType,
    messageId: string,
    operation: "add" | "remove",
    reason?: string,
    suggestedReasons?: string[],
  ) => void;
  className?: string,
  setShowThanksForFeedback: Dispatch<SetStateAction<boolean>>,
  visible: boolean;
}

export default function MessageFeedback({
  messageId,
  onFeedbackSubmit,
  setShowThanksForFeedback,
  visible,
  className,
}: MessageFeedbackProps) {
  const {
    feedbackState,
    handlePositive,
    handleNegative,
    handleSubmitNegative,
    setShowFeedbackModal,
    showFeedbackModal
  } = useFeedbackMessage({ messageId, onFeedbackSubmit, setShowThanksForFeedback });

  if(!visible) return null;

  return (
    <>
      <div className={cn("flex gap-2 mt-2", className)}>
        <Button
          size="sm"
          variant="ghost"
          className={cn(
            "p-2 h-6 w-6 text-muted-primary",
          )}
          onClick={handlePositive}
        >
          <ThumbsUp 
            className="w-3 h-3" 
            strokeWidth={2.25}
            fill={feedbackState?.feedbackType === "positive" ? "currentColor" : "none"}
          />
        </Button>
        <Button
          size="sm"
          variant="ghost"
          className={cn(
            "p-1 h-6 w-6 text-muted-primary",
          )}
          onClick={handleNegative}
        >
          <ThumbsDown 
            className="w-2 h-2 mr-1" 
            strokeWidth={2.25}
            fill={feedbackState?.feedbackType === "negative" ? "currentColor" : "none"}
          />
        </Button>
      </div>

      <MessageFeedbackModal
        open={showFeedbackModal}
        onClose={() => setShowFeedbackModal(false)}
        onSubmit={handleSubmitNegative}
      />
    </>
  )
}
